import type { Space } from "@common/types/space";
import type { TodoIdMap } from "@common/types/todo";
import { UserProfile } from "@common/types/user";
import TodoUtils from "@common/utils/todo-utils";

export const FREE_TIER_MAX_TODOS = 40;
export const FREE_TIER_MAX_SPACES = 3;

export function shouldPaywallOnCreateTodo(
  todoIdMap: TodoIdMap,
  isPremium: boolean
): boolean {
  // const pcMap = TodoUtils.parentChildMap(Object.values(todoIdMap));
  // && !TodoUtils.isBranchComplete(t.id, todoIdMap, pcMap)
  const todoCount = Object.values(todoIdMap).filter((t) => !t.deleted).length;
  return shouldPaywallOnCreateTodoCount(todoCount, isPremium);
}

export function shouldPaywallOnCreateTodoCount(
  todoCount: number,
  isPremium: boolean
): boolean {
  return isPremium ? false : todoCount >= FREE_TIER_MAX_TODOS;
}

export function shouldPaywallOnCreateSpace(
  spaces: Space[],
  isPremium: boolean
): boolean {
  return isPremium ? false : spaces.length >= FREE_TIER_MAX_SPACES;
}
